import Vue from 'vue'
import Vuetify from 'vuetify'
import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#5087e6',
        secondary: '#353e4d',
        disabled: colors.grey.base,
        success: colors.green.base,
        error: colors.red.darken4,
        warning: '#FE7200',
        draft: colors.orange.base,
        release: colors.green.base,
        end: colors.grey.base,
      },
    },
  },
})
